/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tis_Claims_Medical_DescriptionInputs */

const en_tis_claims_medical_description = /** @type {(inputs: Tis_Claims_Medical_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Claim form for medical expenses: Document used to request reimbursement for healthcare services covered by an insurance policy.`)
};

const fr_tis_claims_medical_description = /** @type {(inputs: Tis_Claims_Medical_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Formulaire de réclamation pour dépenses médicales : Document utilisé pour demander le remboursement de services de santé couverts par une police d'assurance.`)
};

/**
* | output |
* | --- |
* | "Claim form for medical expenses: Document used to request reimbursement for healthcare services covered by an insurance policy." |
*
* @param {Tis_Claims_Medical_DescriptionInputs} inputs
* @param {{ locale?: "en" | "fr" }} options
* @returns {LocalizedString}
*/
export const tis_claims_medical_description = /** @type {((inputs?: Tis_Claims_Medical_DescriptionInputs, options?: { locale?: "en" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tis_Claims_Medical_DescriptionInputs, { locale?: "en" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tis_claims_medical_description(inputs)
	return fr_tis_claims_medical_description(inputs)
});